import React from "react";
import "./Ticker.scss";
import newsJSON from "./news.json";

const Title = () => {
  return (
    <div className="title">
      <h2>מבזקים</h2>
    </div>
  );
};

const News = (props) => {
  return (
    <div className="news">
      <h2 className="time">{props.time}</h2>
      <h2 className="text">{props.text}</h2>
    </div>
  );
};

const NewsItems = () => (
  <div className="slide">
    {newsJSON.map((x, index) => (
      <News key={index} time={x.time} text={x.text} />
    ))}
  </div>
);

function Ticker() {
  return (
    <div className="ticker">
      <Title />
      <div className="news-container">
        <NewsItems />
        <NewsItems />
      </div>
    </div>
  );
}

export default Ticker;
